<template>
  <b-modal
    id="lifecycle-abort-modal"
    v-model="show"
    :ok-only="true"
    ok-title="Ок"
    header-bg-variant="warning"
    header-text-variant="light"
    no-close-on-backdrop
    no-close-on-esc
    @ok="onOk"
  >
    <p class="my-4">
      {{ message }}
    </p>
  </b-modal>
</template>

<script>
export default {
  name: 'LifecycleAbortModal',
  computed: {
    show: {
      get() {
        return this.$store.state.lifecycle && this.$store.state.lifecycle.showAbortModal;
      },
      set(v) {
        // Модалка закрывается только через кнопку Ок (см. props no-close-...).
        if (v === false) {
          this.$store.dispatch('lifecycle_ackAbort');
        }
      }
    },
    message() {
      const reason = this.$store.state.lifecycle && this.$store.state.lifecycle.abortModalReason;
      const humanReason = reason === 'frozen'
        ? 'страница была заморожена браузером'
        : 'страница стала скрытой (фоновой) в браузере';

      return `Из-за того, что ${humanReason}, критичная операция была прервана. Пожалуйста, закройте это сообщение и начните загрузку фотографий заново. Нельзя сворачивать страницу пока загружаете фото`;
    }
  },
  methods: {
    onOk() {
      this.$store.dispatch('lifecycle_ackAbort');
    }
  }
};
</script>

<style scoped>
</style>

